import React from "react";
import ItemCard from "./ItemCard";
import Icon from "@material-ui/core/Icon";
import useList from "customHooks/useList";
import _ from "lodash";
import { IFieldProps } from ".";

type ProfessionalHistoryItem = {
    companyName?: string | null;
    currentPosition?: boolean | null;
    endDate?: string | null;
};

const FieldCurrentCompany = (props: IFieldProps) => {
    const { fieldData, fieldName, returnType } = props;
    const [listData] = useList();
    const { t } = listData.tempInfo;
    const { cardFields } = listData.definitionInfo.elasticDefData?.data || {};

    const professionalHistory =
        (_.get(fieldData, "professionalHistory") as
            | ProfessionalHistoryItem[]
            | undefined) || [];

    const currentCompanies = professionalHistory
        .filter((item: ProfessionalHistoryItem) => {
            const isCurrentPosition = item?.currentPosition === true;
            const hasNoEndDate =
                item?.endDate === null ||
                item?.endDate === undefined ||
                item?.endDate === "";
            return (
                (isCurrentPosition || hasNoEndDate) &&
                Boolean(item?.companyName)
            );
        })
        .map((item: ProfessionalHistoryItem) => String(item.companyName).trim())
        .filter(Boolean);

    const uniqueCompanies = Array.from(new Set(currentCompanies));
    const value = uniqueCompanies.length ? uniqueCompanies.join(" | ") : "-";

    switch (returnType) {
        case "card":
            return (
                <ItemCard
                    label={
                        cardFields?.[fieldName]?.cardIcon ? (
                            <Icon color="action" fontSize="small">
                                {cardFields[fieldName].cardIcon}
                            </Icon>
                        ) : (
                            `${t(fieldName)}: `
                        )
                    }
                    removeColonAfterLabel={true}
                >
                    {value}
                </ItemCard>
            );
        case "table":
            return <>{value}</>;
    }
};

export default FieldCurrentCompany;
